import { render, staticRenderFns } from "./CardModal.vue?vue&type=template&id=004a1e48&"
import script from "./CardModal.vue?vue&type=script&lang=js&"
export * from "./CardModal.vue?vue&type=script&lang=js&"
import style0 from "./CardModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports